import { defineNuxtPlugin } from '#app/nuxt';
import { useBlockLibraryStore } from '#layers/block-engine/public';

function getFieldDisplayBlock(id: string) {
	return useBlockLibraryStore().getBlock(id);
}

function isFieldDisplayBlockResolverReady() {
	return useBlockLibraryStore().isReady;
}

export default defineNuxtPlugin(() => {
	return {
		provide: {
			fieldDisplayBlockResolver: {
				getBlock: getFieldDisplayBlock,
				isReady: isFieldDisplayBlockResolverReady,
			},
		},
	};
});
